module.exports = __webpack_public_path__ + "static/media/Bulk Force Close Import Consignments.972c3c36.csv";